import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    closure_row_container: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 3fr 30px',
        gap: '12px',
        padding: '16px',
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px',
        border: `1px solid ${theme.palette.grey[300]}`,
        transition: 'all 0.2s ease',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
            borderColor: theme.palette.primary.light,
            transform: 'translateX(4px)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }
    },
    action_btns: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '8px'
    },
    agency_cell: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        color: theme.palette.secondary.dark
    },
    amount_cell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: '18px'
    },
    date_cell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.grey[700]
    },
    notes_cell: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.grey[600],
        fontSize: '14px',
        fontStyle: 'italic'
    },
    // Estilos para versão mobile/small
    closure_row_small: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '16px',
        backgroundColor: theme.palette.common.white,
        borderRadius: '8px',
        border: `2px solid ${theme.palette.grey[300]}`,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
        '&:hover': {
            borderLeftColor: theme.palette.primary.dark,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
        }
    },
    small_header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '8px',
        borderBottom: `1px solid ${theme.palette.grey[200]}`
    },
    agency_name_small: {
        fontWeight: 700,
        fontSize: '16px',
        color: theme.palette.secondary.dark
    },
    price_small: {
        fontWeight: 800,
        fontSize: '20px !important',
        color: theme.palette.primary.main
    },
    small_details: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    notes_small: {
        fontSize: '13px',
        color: theme.palette.grey[600],
        fontStyle: 'italic',
        lineHeight: 1.4
    },
    notes_label: {
        fontWeight: 600,
        color: theme.palette.grey[700],
        fontStyle: 'normal'
    },
}));

export {useStyles}
